// c:\Projects\client\src\pages\game\gameConstants.js
export const MIN_SIDE_WIDTH = 200;
export const MAX_SIDE_WIDTH = 800;
export const ZOOM_FACTOR = 1.1;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 4;
export const MAX_CANVAS_DPR = 1.5;
export const PAN_SPEED = 30;
export const CLICK_DRAG_THRESHOLD_PX = 6;
export const MIN_RECT_WORLD_SIZE = 8;
export const MIN_SHAPE_WORLD_SIZE = 4;
export const AUTO_SAVE_DEBOUNCE_MS = 900;
export const INFO_PANEL_WIDTH = 320;
export const INFO_PANEL_MIN_LEFT = 12;
export const INFO_PANEL_MIN_TOP = 12;
export const INFO_PANEL_MAX_BOTTOM_PADDING = 120;
export const RESIZE_HANDLE_HIT_RADIUS_PX = 15;
export const HEIGHT_HANDLE_OFFSET_PX = 32;
export const FACE_DOT_OFFSET_PX = 10;
export const FACE_DOT_RADIUS_PX = 4;
export const FACE_DOT_HIT_RADIUS_PX = 12;
export const WORLD_UNITS_PER_FOOT = 10;
export const TEAM_PREVIEW_COLORS = {
    player: "#3B82F6",
    enemy: "#EF4444",
    neutral: "#A855F7",
};

export const DEFAULT_MAX_HP_BY_TERRAIN = {
    floor: 500,
    wall: 1200,
    obstacle: 700,
};
